module.exports = __webpack_public_path__ + "static/media/EPD-logo.f9a962c3.png";